module.exports = __webpack_public_path__ + "static/media/linkedin.3df8ffa9.svg";